














































































import {Component, Vue} from 'vue-property-decorator';
import TimelineTemplate from './views/TimelineTemplate.vue';
import {DataGroup, TimelineEventPropertiesResult, TimelineOptions} from 'vis-timeline/esnext';
import TimelineDialogTemplate from '@/views/timeline/views/TimelineDialogTemplate.vue';
import CalendarTemplate from '@/views/calendar/CalendarTemplate.vue';
import moment from 'moment';
import {IndexedNestedTimelineDataStoreServiceType} from '@/views/timeline/services/timeline-data-store-service.type';
import {MECHANICS_DATA_STORE_SERVICE_INSTANCE} from '@/views/timeline/services/mechanics/mechanics-timeline-data-store.service';
import {MechanicBookingType} from '@/views/timeline/services/booking.types';

@Component({
    components: {
        CalendarTemplate,
        TimelineDialogTemplate,
        TimelineTemplate
    }
})
export default class MechanicsTimelineTemplate extends Vue {

    dataProvider: IndexedNestedTimelineDataStoreServiceType<MechanicBookingType, DataGroup, DataGroup> =
        MECHANICS_DATA_STORE_SERVICE_INSTANCE;

    editItem: MechanicBookingType | null = null; // the current order to be edited
    editItemGroup: DataGroup | null = null; // the current group of the order to be edited

    editGroup: DataGroup | null = null; // the current machine to be edited
    editSuperGroup: DataGroup | null = null; // the current group of the mechanic to be edited

    options: TimelineOptions = {
        minHeight: '100%',
        align: 'left'
    };

    stopEditBooking() {
        // after edit is complete (dialog is closed).
        // delete the dialog in the DOM again by invalidating v-if=editOrder
        this.editItem = null;
        this.editItemGroup = null;
    }

    stopEditMechanic() {
        // after edit is complete (dialog is closed).
        // delete the dialog in the DOM again by invalidating v-if=editMachine
        this.editGroup = null;
        this.editSuperGroup = null;
    }

    onClick(event: TimelineEventPropertiesResult) {
        switch (event.what) {
            case 'item': {
                // clicked on a item
                if (event.item) {
                    const lookupOrderFromIndex =
                        this.dataProvider.getItemIndex().get(event.item);
                    if (lookupOrderFromIndex && event.group) {
                        const lookupGroupFromIndex =
                            this.dataProvider.getGroupIndex().get(event.group);
                        if (lookupGroupFromIndex) {
                            this.editItemGroup = lookupGroupFromIndex;
                        }
                        this.editItem = lookupOrderFromIndex;
                    }
                }
                break;
            }
            case 'group-label': {
                // clicked on a group OR subgroup
                const key: any = event.group; // type mapping is wrong. IDType is the correct one
                if (typeof key === 'string' || typeof key === 'number') {
                    const lookupMechanic =
                        this.dataProvider.getGroupIndex().get(key);
                    if (lookupMechanic) {
                        const lookupGroupFromIndex = this.dataProvider.getSuperGroupByGroup(key);
                        if (lookupGroupFromIndex) {
                            this.editSuperGroup = lookupGroupFromIndex;
                            this.editGroup = lookupMechanic;
                        }
                    }
                }
            }
            default: {
                break;
            }
        }
    }

    formatStartDate(startDate: Date) {
        const startDateMoment = moment(startDate);

        return startDateMoment.format('dddd, DD.MM.YYYY');
    }

    getHumanizedDuration(durationInMillis: number) {
        const hours = moment.duration(durationInMillis).hours();
        const minutes = moment.duration(durationInMillis).minutes();
        let result = `${hours} Stunde(n)`;
        if (minutes) {
            result += `${minutes} Minute(n)`;
        }
        return result;
    }
}
